import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

import type { NodeItem } from '@models/flows';

const TRANSACTION_NATURE_LIST = [
  { label: 'One-time', code: 'one_time', id: uuidv4() },
  { label: 'Subscription Initial', code: 'subscription_initial', id: uuidv4() },
  { label: 'Subscription Recurring', code: 'subscription_recurring', id: uuidv4() },
];

type TransactionNatureNodeConfigurationProps = {
  currentNode: NodeItem;
  onChange: (data: NodeItem) => void;
};

function TransactionNatureNodeConfiguration({
  currentNode,
  onChange,
}: TransactionNatureNodeConfigurationProps) {
  if (!currentNode) return null;

  const handleChange = (event: SelectChangeEvent<string>) => {
    const {
      target: { value },
    } = event;
    const selectedTransactionNature = TRANSACTION_NATURE_LIST.find(
      (transactionNature) => transactionNature.code === value,
    );

    if (selectedTransactionNature) {
      onChange({
        code: selectedTransactionNature.code,
        label: selectedTransactionNature.label,
        id: currentNode.id,
      });
    }
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="conditional-node-select-label">Conditionals</InputLabel>
      <Select
        labelId="conditional-node-select-label"
        id="conditional-node-simple-select"
        value={currentNode.code || ''}
        label="Conditionals..."
        onChange={handleChange}
        MenuProps={{ disablePortal: true }}>
        {TRANSACTION_NATURE_LIST.map(({ label, code }) => (
          <MenuItem key={code} value={code}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default TransactionNatureNodeConfiguration;
